<template>
    <div>
        <el-button plain @click="showCreateDialoe">添加素材</el-button>
        <el-button plain @click="uploadFile">上传素材</el-button>
        <el-button type="primary" icon="el-icon-search" @click="tuneList">加载</el-button>
        <el-table
        @selection-change="handleSelectionChange"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        :row-class-name="tableRowClassName">
        <el-table-column
        type="selection"
        prop="id"
        width="55">
        </el-table-column>
        <el-table-column
            prop="id"
            label="ID"
            width="260">
        </el-table-column>
        <el-table-column
            prop="file_id"
            label="file_id"
            width="180">
        </el-table-column>
        <el-table-column
            prop="file_path"
            label="文件路径">
        </el-table-column>
        <el-table-column
            prop="prompt"
            label="问">
        </el-table-column>
        <el-table-column
            prop="completion"
            label="答">
        </el-table-column>
     
        <el-table-column
            prop="add_time"
            label="创建时间">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.add_time) }}</span>

            </template>
        </el-table-column>
        <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button @click="deleteData(scope.row.id)" circle>删除</el-button>
              <el-button @click="editData(scope.row.id)" circle>编辑</el-button>
            </template>
        </el-table-column>
        </el-table>

        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <span>
                
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
                
                <el-form-item
                    v-for="(domain, index) in dynamicValidateForm.domains"
                    :label="'微调' + index"
                    :key="domain.key"
                    :prop="'domains.' + index + '.completion'"
                    :rules="{
                    required: true, message: '不能为空', trigger: 'blur'
                    }"
                >
                <el-input v-model="domain.prompt" type="textarea" placeholder="请输入问题/prompt"></el-input>
                    <el-input v-model="domain.completion" type="textarea" placeholder="请输入答案/completion"></el-input>
                    
                    <el-button @click.prevent="removeDomain(domain)">删除</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addDomain">新增条目</el-button>
                    <el-button @click="resetForm('dynamicValidateForm')">重置</el-button>
                </el-form-item>
            </el-form>

            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('dynamicValidateForm')">确 定</el-button>
            </span>
          </el-dialog>

          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="params.pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </div>
  </template>
  
  <style>
    .el-table .warning-row {
      background: oldlace;
    }
  
    .el-table .success-row {
      background: #f0f9eb;
    }
  </style>
  
  <script>

  import {Message} from 'element-ui';
    export default {
      name:'FineTuneFile',
      data() {
        return {
          params:{
            pageid:1,
            pagesize:10,
            file_id:null
          },
          multipleSelection:[],
          total:0,
          currentPage:1,
          centerDialogVisible: false,
          tableData: [],
          dynamicValidateForm: {
            domains: [{
                completion: '',
                prompt:''
            }]
         },
         form:{}
        }
      },
      methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.params.pagesize = val;
            this.tuneList();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.params.pageid = val;
            this.tuneList();
        },
        tableRowClassName({row, rowIndex}) {
          if (rowIndex === 1) {
            return 'warning-row';
          } else if (rowIndex === 3) {
            return 'success-row';
          }
          return '';
        },
        deleteData(id){

            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
             type: 'warning'
            }).then(() => {
                let self = this;
                let params = {
                    id : id
                }
                console.log('id:'+id);
                self.postRequest('/fineTuneFile/delete',params).then(resp =>{
                Message.success({message: resp.msg})
                self.tuneList();
                })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });

          
        },
        tuneList(){
            let self = this;
            self.postRequest('/fineTuneFile/list',self.params).then(resp =>{
             self.tableData = resp.data.rows;
             self.currentPage = resp.data.pageid;
             self.total = resp.data.recordcount;
            })
        },
        showCreateDialoe(){
            this.centerDialogVisible = true;
        },
        submitForm(formName) {
            console.log("formName:"+JSON.stringify(this.dynamicValidateForm));
            this.centerDialogVisible=false;
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let self = this;
                var pa = self.dynamicValidateForm;
     
                var p = {params:JSON.stringify(pa)};
                console.log("p:"+p);
                self.postRequest('/fineTuneFile/add',p).then(resp =>{
                    Message.success({message: resp.msg})
                    self.tuneList();
                    self.resetForm(formName);
                })  

            } else {
                Message.error({message: "表单验证失败"})
                return false;
            }
            });
      },
      editData(id){
        let self = this;
        self.centerDialogVisible = true;
        let dat = {
            id:id
        }
        self.postRequest('/fineTuneFile/get',dat).then(resp =>{
             let da = resp.data;
             let arra = [{
                completion: da.completion.replace('.END',''),
                prompt:da.prompt,
                id:da.id
             }];
             self.dynamicValidateForm.domains = arra
            })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      removeDomain(item) {
        var index = this.dynamicValidateForm.domains.indexOf(item)
        if (index !== -1) {
          this.dynamicValidateForm.domains.splice(index, 1)
        }
      },
      addDomain() {
        self.resetForm( this.dynamicValidateForm);
        this.dynamicValidateForm.domains.push({
          completion: '',
          prompt:'',
          key: Date.now()
        });
      },
      uploadFile(){
        let self = this;
        if(self.multipleSelection.length == 0){
          Message.error({message: "请选择要上传的内容"})
          return;
        }
        this.$confirm('上传数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
             type: 'warning'
            }).then(() => {
              
              self.postRequest('/fineTuneFile/upload_file',{array:JSON.stringify(self.multipleSelection)}).then(resp =>{
                  Message.success({message: resp.msg})
                  self.tuneList();
              })
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });


       
      },
      handleSelectionChange(val) {
        var array = [];
        for(var i in val){
            array.push(val[i].id);
        }
        this.multipleSelection = array;
        console.log(this.multipleSelection);
      }
      },
      created(){
      this.tuneList();
     }
    }
  </script>